<template>
    <div>
        <template v-if="cancellationPending">
            <b-alert show variant="warning">
                <span>There is a pending cancellation for this service. </span>
                <span v-if="cancellationImmediate">This service will be deactivated shortly.</span>
                <span v-else-if="cancellationDate">This service will be deactivated on your next invoice date ({{ cancellationDate | moment('DD/MM/YYYY') }}).</span>
                <span v-else>This service will be deactivated on your next invoice date.</span>
            </b-alert>
        </template>
    </div>
</template>

<script>
export default {
    props: ['service'],
    computed: {
        cancellationPending() {
            return this.service?.billing?.cancellation?.pending || false;
        },
        cancellationImmediate() {
            return this.service?.billing?.cancellation?.immediate || false;
        },
        cancellationDate() {
            return this.service?.billing?.cancellation?.date || null;
        },
    }
}
</script>